(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-propos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ── Le plafond de l'empilement ──────────────────────────────────────
    // La demande est explicite : les cartes se collent SOUS la nav-bar, pas en
    // haut de l'ecran. L'en-tete du theme est lui-meme colle, donc un top a
    // zero glisserait dessous.
    //
    // Mesure plutot que valeur en dur : l'en-tete fait 69 sur ordinateur mais
    // pas ailleurs, et il n'y a aucune variable de theme qui porte sa hauteur.
    // On cherche le plus haut element reellement colle en haut de page, ce qui
    // reste juste le jour ou la banniere d'annonce se collera aussi.
    function mesurerPlafond(scope) {
      var page = (scope || document).querySelector('.ap');
      if (!page) return;
      var haut = 0;
      document.querySelectorAll('body *').forEach(function (el) {
        var st = getComputedStyle(el);
        if (st.position !== 'sticky' && st.position !== 'fixed') return;
        if (parseFloat(st.top) !== 0) return;
        var r = el.getBoundingClientRect();
        // Un element colle en haut ET pose en haut : les fenetres surgissantes
        // (consentement, retour a l'accueil) n'entrent pas dans le compte.
        if (r.top > 4 || r.height > 240) return;
        if (r.height > haut) haut = r.height;
      });
      if (haut > 0) page.style.setProperty('--ap-plafond', haut + 'px');
    }

    // ── La frise rejoint la pile seulement si elle y tient ────────────────
    // Signale le 11/09 : sur ordinateur, la frise restait en defilement normal
    // alors qu'elle avait la place de se coller. La feuille de style devinait
    // sa taille depuis la LARGEUR de la fenetre — 720 au pire, mesure a 900 de
    // large — et exigeait un plafond de fenetre assez haut pour ce pire des
    // cas. Une frise reellement plus courte (moins d'etapes, une traduction
    // plus breve) restait exclue de l'empilement alors qu'elle y tenait.
    //
    // On mesure donc la frise elle-meme plutot que de deviner sa taille : si
    // sa hauteur reelle passe sous ce qui reste de fenetre une fois le
    // plafond retranche, la classe autorise la feuille de style a la coller
    // (voir .ap--frise-empilable dans le CSS). Sans elle, defilement normal —
    // toujours une degradation, jamais une panne.
    //
    // scrollHeight et non getBoundingClientRect().height : la frise est en
    // position normale au moment de la mesure, donc les deux se valent ici,
    // mais scrollHeight reste correct meme si un ancetre venait un jour a la
    // rogner.
    function evaluerFrise(scope) {
      var page = (scope || document).querySelector('.ap');
      var frise = (scope || document).querySelector('.ap__timeline');
      if (!page || !frise) return;
      var plafond = parseFloat(getComputedStyle(page).getPropertyValue('--ap-plafond')) || 0;
      var disponible = window.innerHeight - plafond;
      page.classList.toggle('ap--frise-empilable', frise.scrollHeight <= disponible);
    }

    // ── La cascade de la frise ──────────────────────────────────────────
    // La classe `is-pret` est posee AVANT d'observer, et c'est elle qui masque
    // les etapes : si ce script ne tourne pas, elle n'arrive jamais et la frise
    // s'affiche telle quelle. Masquer depuis la feuille aurait rendu la section
    // invisible au moindre incident.
    function cascade(scope) {
      var frise = (scope || document).querySelector('.ap__frise');
      if (!frise || frise.dataset.apCascade) return;
      frise.dataset.apCascade = '1';

      // Pas d'observateur : on affiche sans ceremonie, sans jamais masquer.
      if (!('IntersectionObserver' in window)) return;

      frise.classList.add('is-pret');

      function montrer() {
        frise.classList.add('is-vu');
      }

      var aRepondu = false;
      var obs = new IntersectionObserver(function (entrees) {
        aRepondu = true;   // il a parle, meme pour dire « pas encore visible »
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          montrer();
          obs.disconnect();   // une seule fois : ce n'est pas un aller-retour
        });
      }, { threshold: 0.15 });

      obs.observe(frise);

      // ── Le filet ──────────────────────────────────────────────────────
      // Cette cascade MASQUE du contenu, et c'est ce qui la rend risquee : si
      // l'observateur ne repond jamais, les six etapes restent invisibles et la
      // section est vide sans que rien ne le signale.
      //
      // On ne guette donc pas la visibilite mais la REPONSE : l'observateur
      // rappelle une premiere fois des qu'il est branche, meme pour dire que
      // rien n'est visible. S'il n'a rien dit au bout de trois secondes, c'est
      // qu'il ne dira rien — on affiche. Le procede a ete pris en defaut a
      // l'essai, dans un cadre ou la fenetre mesurait 0 x 0 : la page n'a alors
      // aucune surface visible et aucun rappel n'arrive.
      //
      // Guetter la visibilite plutot que la reponse aurait devoile la frise a
      // tout le monde au bout de trois secondes, effet compris.
      setTimeout(function () {
        if (!aRepondu) {
          obs.disconnect();
          montrer();
        }
      }, 3000);
    }

    function init(scope) {
      var root = scope || document;
      mesurerPlafond(scope);
      evaluerFrise(scope);
      cascade(scope);
      root.querySelectorAll('[data-ap-video] video').forEach(function (video) {
        if (video.dataset.apObserved) return;
        video.dataset.apObserved = '1';

        // Set as properties, not just attributes: a scripted play() outside a
        // user gesture is refused unless the element is genuinely muted, and
        // loop is pinned here so the divider keeps running whatever the markup
        // ended up saying.
        video.muted = true;
        video.loop = true;

        if (!('IntersectionObserver' in window)) {
          video.preload = 'auto';
          var fallback = video.play();
          if (fallback && fallback.catch) fallback.catch(function () {});
          return;
        }

        // Two observers, because buffering and playing want different moments.
        // Starting both at the same point is what made the divider stutter: it
        // began playing against an empty buffer and spent the first seconds
        // catching up with the stream.

        // Buffer first. Two viewport heights of warning is roughly a scroll
        // gesture away, which is enough for the player to build a cushion
        // before anyone sees a frame — and it still costs nothing to a visitor
        // who never scrolls down that far.
        var preloader = new IntersectionObserver(
          function (entries, self) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              video.preload = 'auto';
              video.load();
              self.disconnect();
            });
          },
          { rootMargin: '200% 0px' }
        );
        preloader.observe(video);

        // Then play, once a quarter of the divider is genuinely on screen.
        var player = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var played = video.play();
                // Rejects if the tab is backgrounded or autoplay is denied;
                // there is nothing to recover, and an unhandled rejection
                // would surface in the console for no reason.
                if (played && played.catch) played.catch(function () {});
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { threshold: 0.25 }
        );
        player.observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // The theme editor swaps section markup without reloading the page.
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });

    // La fenetre change de hauteur (redimensionnement, rotation, barre du
    // navigateur qui se retracte au defilement sur mobile) : la frise doit
    // regagner ou perdre l'empilement en consequence, pas rester figee sur la
    // mesure du chargement.
    window.addEventListener('resize', function () {
      mesurerPlafond();
      evaluerFrise();
    });

    // ── L'adresse suit le chapitre qu'on lit ─────────────────────────────
    // Même intention que le catalogue (sections/collection.liquid, majAdresse) :
    // chaque chapitre a son adresse, donc un lien partagé ouvre la page au bon
    // endroit au lieu de la faire traverser au visiteur.
    //
    // La différence tient à Shopify, pas à un choix : le catalogue s'appuie sur
    // /collections/boutique/<tag>, une route de collection filtrée par tag que
    // Liquid relit côté serveur. Un handle de page est plat — il n'existe pas de
    // /pages/notre-concept/les-fondateurs à servir — donc le chapitre passe
    // par le fragment, que le navigateur sait déjà atteindre tout seul.
    //
    // Mesuré au défilement, et NON par IntersectionObserver : le panneau de
    // prévisualisation de l'éditeur ne déclenche aucun observateur, si bien que
    // le comportement n'y serait pas vérifiable. C'est la raison qui vaut déjà
    // pour majZone dans le catalogue.
    (function () {
      if (!window.history || !window.history.replaceState) return;

      // Semé depuis l'adresse d'arrivée : un lien du menu ouvre la page sur son
      // chapitre, et le premier passage ci-dessous ne doit pas le réécrire s'il
      // mesure une page dont les photos n'ont pas fini de se poser. Sans hash,
      // la valeur reste nulle et l'adresse nomme le chapitre d'ouverture.
      var chapitreCourant = window.location.hash.slice(1) || null;

      function majAdresse() {
        // Le marqueur, et non une classe : la frise est une <section> quand les
        // autres chapitres sont des .ap__row. querySelectorAll rend l'ordre du
        // document, qui est l'ordre de lecture.
        var chapitres = document.querySelectorAll('[data-ap-chapitre][id]');
        if (!chapitres.length) return;

        // Le repère est le milieu de l'écran : on lit le chapitre que la ligne
        // médiane traverse. C'est la façon habituelle de répondre à « quelle
        // section suis-je en train de lire », et celle du catalogue.
        var mire = window.innerHeight / 2;
        var trouve = null;

        for (var i = 0; i < chapitres.length; i++) {
          var boite = chapitres[i].getBoundingClientRect();
          if (boite.top <= mire && boite.bottom > mire) {
            trouve = chapitres[i].id;
            break;
          }
          // Dans un interstice, ou avant le premier chapitre, on prend celui
          // qui vient : l'en-tête de page n'est pas un chapitre et n'a pas
          // d'adresse à porter.
          if (boite.top > mire) {
            trouve = chapitres[i].id;
            break;
          }
        }

        // Passé le dernier chapitre — le pied de page — l'adresse y reste
        // plutôt que de retomber sur le premier.
        if (!trouve) trouve = chapitres[chapitres.length - 1].id;
        if (trouve === chapitreCourant) return;
        chapitreCourant = trouve;

        // replaceState et non pushState : traverser la page au défilement ne
        // doit pas empiler cinq entrées dans l'historique, où le bouton Retour
        // se mettrait à remonter la page chapitre par chapitre.
        window.history.replaceState(null, '', window.location.pathname + '#' + trouve);
      }

      // `passive` : on ne bloque jamais le défilement.
      window.addEventListener('scroll', majAdresse, { passive: true });
      window.addEventListener('resize', majAdresse);

      // Le premier passage attend `load`, et non l'analyse du document : le
      // navigateur restaure la position de défilement d'une page revisitée
      // APRÈS celle-ci. Mesurer trop tôt, c'est lire scrollY à zéro et publier
      // « les-fondateurs » sur une page rouverte au milieu — l'adresse restait
      // fausse jusqu'au premier coup de molette. Les photos ont fini de se
      // poser à ce moment-là, donc les mesures sont bonnes du premier coup.
      if (document.readyState === 'complete') {
        majAdresse();
      } else {
        window.addEventListener('load', majAdresse);
      }
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avis-clients"] && !Shopify.designMode) return;
  try {
    
  // Les flèches du carrousel d'avis. Elles ne font que déléguer à la piste :
  // c'est le conteneur à défilement qui porte l'état, pas le script. Sans ce
  // fichier, la piste se fait toujours glisser au doigt, à la molette et au
  // clavier — les deux boutons restent simplement cachés, comme ils le sont
  // dans le balisage.
  (function () {
    function setup(root) {
      if (root.dataset.avisInit) return;
      root.dataset.avisInit = '1';

      var track = root.querySelector('[data-avis-track]');
      var prev = root.querySelector('[data-avis-prev]');
      var next = root.querySelector('[data-avis-next]');
      if (!track || !prev || !next) return;

      // Un pas = une carte et sa gouttière, mesurées et non devinées : la
      // largeur des cartes est un clamp, donc elle change avec la fenêtre.
      function pas() {
        var carte = track.querySelector('.avis__card');
        if (!carte) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return carte.getBoundingClientRect().width + gap;
      }

      // Une marge de 2px : les largeurs sont fractionnaires, et une piste
      // arrivée au bout affiche parfois 0,4px de retard. Sans elle, la flèche
      // de fin ne disparaît jamais.
      function majFleches() {
        var reste = track.scrollWidth - track.clientWidth;
        var deborde = reste > 2;
        prev.hidden = !deborde || track.scrollLeft <= 2;
        next.hidden = !deborde || track.scrollLeft >= reste - 2;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -pas(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: pas(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', majFleches, { passive: true });
      window.addEventListener('resize', majFleches);

      // Les images arrivent après le premier calcul et changent la hauteur,
      // pas la largeur — mais une police qui finit de charger, elle, change
      // les deux. On repasse donc une fois la page vraiment prête.
      window.addEventListener('load', majFleches);

      majFleches();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-avis]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // L'éditeur de thème remplace le balisage d'une section sans recharger.
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /**
   * Le panier se regle sans recharger la page.
   *
   * Les deux pas « - » et « + », le lien « Retirer » et le champ de quantite
   * pointaient tous vers /cart/change par une NAVIGATION : chaque clic
   * rechargeait la page entiere, on perdait sa place et l'ecran clignotait.
   *
   * Ils passent desormais par /cart/change.js, et c'est le Section Rendering
   * API qui redessine — on demande a Shopify de re-rendre la section du panier
   * et celle de l'en-tete, puis on remplace leur contenu.
   *
   * Redessiner plutot que rapiecer le DOM a la main, et la raison vaut d'etre
   * ecrite : une ligne de panier ne porte pas qu'une quantite. Elle porte son
   * total et ses remises, et la page porte le sous-total, la barre de livraison
   * offerte, le compte d'articles, l'etat vide quand la derniere ligne s'en va.
   * Tout recalculer en JavaScript, c'est reecrire le Liquid une seconde fois —
   * et le voir diverger au premier changement de prix.
   *
   * Sans JavaScript, rien ne change : les liens gardent leur href et la
   * navigation reprend la main.
   */
  (function () {
    var enCours = false;

    function racine() {
      return document.querySelector('[data-cart-page]');
    }

    // L'en-tete est une AUTRE section : son compte d'articles doit suivre,
    // sinon le panier se vide pendant qu'il en annonce encore trois.
    function idsSections(page) {
      var ids = [page.dataset.cartSection];
      var entete = document.querySelector('[data-site-header]');
      var enveloppe = entete && entete.closest('[id^="shopify-section-"]');
      if (enveloppe) ids.push(enveloppe.id.replace('shopify-section-', ''));
      return ids;
    }

    function remplacer(id, html) {
      var cible = document.getElementById('shopify-section-' + id);
      if (!cible || !html) return;
      var neuf = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('shopify-section-' + id);
      if (neuf) cible.innerHTML = neuf.innerHTML;
    }

    // Le bouton « Mettre a jour » n'existe que pour le cas ou ce script ne
    // tourne pas. Masque au demarrage, et re-masque apres chaque reaffichage :
    // il revient avec le Liquid.
    function masquerLeSecours() {
      var page = racine();
      if (!page) return;
      var secours = page.querySelector('[data-cart-update]');
      if (secours) secours.hidden = true;
    }

    function changer(ligne, quantite) {
      var page = racine();
      if (!page || enCours) return;
      enCours = true;
      page.setAttribute('aria-busy', 'true');

      var ids = idsSections(page);

      fetch(page.dataset.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(ligne),
          quantity: Number(quantite),
          sections: ids.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/change ' + r.status);
          return r.json();
        })
        .then(function (data) {
          ids.forEach(function (id) {
            remplacer(id, data.sections && data.sections[id]);
          });
          masquerLeSecours();
        })
        .catch(function () {
          // Le reseau a lache, ou Shopify a refuse : on recharge, ce que le lien
          // aurait fait de toute facon. Mieux vaut un panier juste et un
          // clignotement qu'un panier faux et silencieux.
          window.location.reload();
        })
        .then(function () {
          enCours = false;
          var p = racine();
          if (p) p.removeAttribute('aria-busy');
        });
    }

    // Delegue sur le document, et non sur la section : celle-ci est REMPLACEE a
    // chaque mise a jour, et un ecouteur pose dessus partirait avec elle.
    function init() {
      if (document.body.dataset.cartAjax) return;
      document.body.dataset.cartAjax = '1';

      document.addEventListener('click', function (event) {
        var page = racine();
        if (!page || !page.contains(event.target)) return;
        var lien = event.target.closest('a[href*="/cart/change"]');
        if (!lien) return;

        var url;
        try {
          url = new URL(lien.href, window.location.origin);
        } catch (e) {
          return; // href illisible : on laisse le lien faire son travail
        }
        var ligne = url.searchParams.get('line');
        var quantite = url.searchParams.get('quantity');
        if (ligne === null || quantite === null) return;

        event.preventDefault();
        changer(ligne, quantite);
      });

      // La valeur tapee au clavier, qui envoyait le formulaire entier.
      document.addEventListener('change', function (event) {
        var page = racine();
        if (!page || !page.contains(event.target)) return;
        var champ = event.target.closest('[data-cart-qty]');
        if (!champ || !champ.dataset.cartLine) return;
        // Champ vide ou valeur absurde : on laisse la main plutot que de
        // renvoyer un panier au contenu devine.
        if (champ.value === '' || Number(champ.value) < 0) return;
        changer(champ.dataset.cartLine, champ.value);
      });
    }

    function demarrer() {
      init();
      masquerLeSecours();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', demarrer);
    } else {
      demarrer();
    }

    document.addEventListener('shopify:section:load', demarrer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  // Le menu de la FAQ, d'ancres à onglets. Voir l'en-tête de la section pour
  // ce qui subsiste quand ce fichier ne s'exécute pas : tout, sauf la
  // commutation.
  (function () {
    function setup(root) {
      if (root.dataset.faqInit) return;
      root.dataset.faqInit = '1';

      var list = root.querySelector('[data-faq-tablist]');
      var groups = root.querySelector('[data-faq-groups]');
      if (!list || !groups) return;

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-faq-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-faq-panel]'));

      // Un seul thème, ou un menu qui ne correspond pas aux groupes : il n'y a
      // rien à commuter, et la page déroulée reste la bonne réponse.
      if (tabs.length < 2) return;
      if (tabs.length !== panels.length) return;

      groups.classList.add('is-tabbed');
      list.setAttribute('role', 'tablist');

      // Le declencheur du deroulant (telephone). Il porte `hidden` dans le
      // balisage : sans script il n'y a rien a deplier, et la liste reste
      // affichee telle quelle. C'est donc ici, et seulement ici, qu'il existe.
      var tabsToggle = root.querySelector('[data-faq-tabs-toggle]');
      var tabsLabel = root.querySelector('[data-faq-tabs-label]');

      function setTabsOpen(open) {
        if (!tabsToggle) return;
        list.classList.toggle('is-open', open);
        tabsToggle.setAttribute('aria-expanded', String(open));
      }

      if (tabsToggle) {
        tabsToggle.hidden = false;

        tabsToggle.addEventListener('click', function (event) {
          // Sans quoi l'ecouteur « clic a cote » ci-dessous, qui vit sur le
          // document, refermerait le panneau dans la foulee de son ouverture.
          event.stopPropagation();
          setTabsOpen(!list.classList.contains('is-open'));
        });

        document.addEventListener('click', function (event) {
          if (list.contains(event.target)) return;
          if (tabsToggle.contains(event.target)) return;
          setTabsOpen(false);
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') setTabsOpen(false);
        });
      }

      function select(index, moveFocus) {
        for (var i = 0; i < tabs.length; i++) {
          var on = i === index;
          tabs[i].classList.toggle('is-active', on);
          tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
          tabs[i].tabIndex = on ? 0 : -1;
          // « until-found » plutôt qu'un hidden sec : Chrome retrouve alors le
          // texte des onglets fermés avec Ctrl+F, et prévient par
          // « beforematch » pour qu'on ouvre le bon. Les autres navigateurs
          // ignorent la valeur et masquent, ce qui est déjà l'attendu.
          if (on) panels[i].removeAttribute('hidden');
          else panels[i].setAttribute('hidden', 'until-found');
        }
        // Le bouton porte le nom du theme ouvert, et choisir referme le
        // panneau : c'est le geste attendu d'un deroulant.
        if (tabsLabel) tabsLabel.textContent = tabs[index].textContent.trim();
        setTabsOpen(false);

        if (moveFocus) tabs[index].focus();
      }

      function indexOfHash(hash) {
        if (!hash) return -1;
        for (var i = 0; i < panels.length; i++) {
          if ('#' + panels[i].id === hash) return i;
        }
        return -1;
      }

      tabs.forEach(function (tab, i) {
        var panel = panels[i];

        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
        if (tab.id) panel.setAttribute('aria-labelledby', tab.id);

        // Le href reste l'ancre du groupe : sans script il y mène, avec script
        // il commute sans faire sauter la page ni empiler d'historique.
        tab.addEventListener('click', function (event) {
          event.preventDefault();
          select(i, false);
        });

        tab.addEventListener('keydown', function (event) {
          var next = -1;
          if (event.key === 'ArrowDown') next = (i + 1) % tabs.length;
          else if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          if (next < 0) return;
          event.preventDefault();
          select(next, true);
        });

        panel.addEventListener('beforematch', function () {
          select(i, false);
        });
      });

      var fromHash = indexOfHash(window.location.hash);
      select(fromHash >= 0 ? fromHash : 0, false);

      // Masquer les groupes qui précédaient la cible remonte la page sous les
      // yeux du lecteur : le navigateur avait défilé vers l'ancre avant que le
      // script ne passe. On refait donc le geste une fois la mise en page
      // arrêtée.
      if (fromHash >= 0) root.scrollIntoView();

      window.addEventListener('hashchange', function () {
        var index = indexOfHash(window.location.hash);
        if (index >= 0) select(index, false);
      });

      // Éditeur de thème : sélectionner un bloc doit amener sous les yeux ce
      // qu'il désigne — l'onglet de son thème, et la question dépliée si c'en
      // est une.
      document.addEventListener('shopify:block:select', function (event) {
        if (!root.contains(event.target)) return;
        var panel = event.target.closest('[data-faq-panel]');
        var index = panels.indexOf(panel);
        if (index >= 0) select(index, false);
        if (event.target.tagName === 'DETAILS') event.target.open = true;
      });
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-faq]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // L'éditeur de thème remplace le balisage d'une section sans recharger.
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      var root = scope || document;
      var footers = root.querySelectorAll('.site-footer');

      footers.forEach(function (footer) {
        if (footer.dataset.footerAnim) return;
        footer.dataset.footerAnim = '1';

        // Deux raisons de ne rien animer : le visiteur a demandé moins de
        // mouvement, ou le navigateur ne sait pas observer l'entrée dans le
        // champ. Dans les deux cas .is-anim n'est jamais posée et l'état
        // masqué du CSS ne s'applique pas — le pied de page reste visible.
        var still = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (still.matches || !('IntersectionObserver' in window)) return;

        footer.classList.add('is-anim');

        // Preuve de vie de l'observateur. Un IntersectionObserver livre une
        // premiere entree des le debut de l'observation, que la cible soit
        // visible ou non : recevoir quoi que ce soit suffit donc a savoir
        // qu'il fonctionne, sans rien dire de l'endroit ou l'on se trouve dans
        // la page.
        var delivered = false;

        // Filet de securite. Tant que .is-anim est posee, le pied de page est
        // masque et n'attend que .is-in : si l'observateur ne livre jamais
        // rien, il resterait invisible pour de bon (c'est le cas du panneau de
        // previsualisation de Claude Code, ou aucun IntersectionObserver ne se
        // declenche). Le filet ne se declenche donc QUE dans ce cas.
        //
        // Ce garde-fou est le coeur du correctif du 26/08 : une premiere
        // version revelait apres 1200 ms sans condition, si bien que sur une
        // page longue — l'accueil — l'animation se jouait pendant que le pied
        // de page etait encore a 3000 px sous l'ecran. Arrive en bas, tout
        // etait deja en place et rien ne bougeait plus.
        setTimeout(function () {
          if (!delivered) footer.classList.add('is-in');
        }, 1200);

        var observer = new IntersectionObserver(
          function (entries) {
            delivered = true;
            entries.forEach(function (entry) {
              // Deux seuils, et non un test sur isIntersecting : ce dernier est
              // vrai des qu'il reste un pixel a l'ecran, il ne redeviendrait
              // donc jamais faux au bon moment.
              //
              // 12% pour jouer : le pied de page est haut, attendre la moitie
              // ferait demarrer la cascade quand elle est deja passee.
              //
              // 0% pour rearmer, et pas 12% : la remise a l'etat masque ne doit
              // se produire qu'une fois le pied de page entierement sorti de
              // l'ecran. A 12% on verrait le contenu s'effacer sous les yeux du
              // visiteur avant qu'il ait fini de remonter.
              //
              // Entre les deux, rien ne bouge : l'observateur ne se deconnecte
              // plus (il le faisait jusqu'au 26/08), donc redescendre rejoue
              // l'animation.
              if (entry.intersectionRatio >= 0.12) {
                footer.classList.add('is-in');
              } else if (entry.intersectionRatio <= 0) {
                footer.classList.remove('is-in');
              }
            });
          },
          { threshold: [0, 0.12] }
        );

        observer.observe(footer);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // L'éditeur de thème remplace le balisage de la section sans recharger.
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formulaire-contact"] && !Shopify.designMode) return;
  try {
    
  // Une case masquée reste envoyée avec le formulaire : c'est `disabled`, et
  // lui seul, qui l'en retire. Le CSS s'occupe déjà de la montrer et de la
  // cacher — ce script ne double pas ce travail, il le complète.
  (function () {
    function sync(select) {
      var form = select.form;
      if (!form) return;

      var kit = form.querySelector('[data-contact-kit]');
      if (kit) {
        var isPress = select.value === 'presse_medias';
        kit.disabled = !isPress;
        if (!isPress) kit.checked = false;
      }

      // Le sujet « Revendeur » ouvre deux pieces : le numero de telephone, et
      // la case de rappel sous la zone de message. Masquees, elles sont mises
      // hors jeu — un champ cache mais actif partirait quand meme avec le
      // formulaire, et un champ cache mais obligatoire bloquerait l'envoi sans
      // que rien ne l'explique a l'ecran.
      var isReseller = select.value === 'revendeur';
      var phone = form.querySelector('[data-contact-phone]');
      if (phone) {
        phone.disabled = !isReseller;
        phone.required = isReseller;
        if (!isReseller) phone.value = '';
      }

      var callback = form.querySelector('[data-contact-callback]');
      if (callback) {
        callback.disabled = !isReseller;
        if (!isReseller && callback.checked) {
          callback.checked = false;
          releaseMessage(form);
        }
      }
    }

    // La zone de message quand la case de rappel est cochee. On garde ce que
    // l'utilisateur avait ecrit : il le retrouve intact s'il se ravise, ce
    // qu'un simple effacement lui aurait coute.
    function holdMessage(form, sentence) {
      var box = form.querySelector('.contact__textarea');
      if (!box || box.readOnly) return;
      box.dataset.contactDraft = box.value;
      box.value = sentence;
      box.readOnly = true;
      box.required = false;
    }

    function releaseMessage(form) {
      var box = form.querySelector('.contact__textarea');
      if (!box || !box.readOnly) return;
      box.value = box.dataset.contactDraft || '';
      delete box.dataset.contactDraft;
      box.readOnly = false;
      box.required = true;
    }

    document.querySelectorAll('[data-contact-callback]').forEach(function (box) {
      var form = box.form;
      if (!form) return;
      box.addEventListener('change', function () {
        if (box.checked) holdMessage(form, box.dataset.sentence || box.value);
        else releaseMessage(form);
      });
    });

    document.querySelectorAll('[data-contact-subject]').forEach(function (select) {
      sync(select);
      select.addEventListener('change', function () {
        sync(select);
      });
    });

    // ── Prénom + nom reconstituent le champ « name » de Shopify ────────────
    // Prénom et nom sont deux champs normaux (contact[Prénom], contact[Nom]) :
    // Shopify ne les reconnaît pas comme identité. Le champ caché
    // contact[name] est celui qu'il lit pour la colonne « Nom » de la
    // notification — il doit donc porter les deux réunis, retenu à chaque
    // frappe plutôt qu'au seul envoi, pour rester juste même si le script
    // d'un bloqueur de scripts tiers coupe l'écouteur `submit`.
    document.querySelectorAll('[data-contact-first-name]').forEach(function (first) {
      var form = first.form;
      if (!form) return;
      var last = form.querySelector('[data-contact-last-name]');
      var hidden = form.querySelector('[data-contact-name]');
      if (!last || !hidden) return;

      // Pas d'appel immédiat ici : au chargement, les deux champs visibles
      // sont vides (Shopify n'a jamais su les remplir depuis form.name,
      // voir le commentaire du balisage) alors que le champ caché porte
      // peut-être déjà, lui, le nom d'un envoi précédent en erreur. Un appel
      // ici l'écraserait par du vide avant même la première frappe.
      function majNom() {
        hidden.value = [first.value, last.value].filter(Boolean).join(' ').trim();
      }

      first.addEventListener('input', majNom);
      last.addEventListener('input', majNom);
    });

    // La fenêtre de confirmation est déjà ouverte dans le balisage — le serveur
    // l'a rendue parce que le formulaire vient de partir. On ne l'ouvre donc
    // pas : on la REOUVRE en modale, ce qui ajoute l'arrière-plan assombri, la
    // touche Échap et le piège à focus. Sans JavaScript elle reste simplement
    // ouverte dans le flux, et dit la même chose.
    var pop = document.querySelector('[data-contact-pop]');
    if (pop) {
      if (pop.showModal) {
        pop.close();
        pop.showModal();
      }

      var close = pop.querySelector('[data-contact-pop-close]');
      if (close) {
        close.addEventListener('click', function () {
          pop.close();
        });
      }

      // Clic à côté de la fenêtre : la cible est le <dialog> lui-même, parce
      // que le clic tombe hors de sa boîte intérieure et que ::backdrop n'est
      // pas une cible d'événement. Même geste que la fenêtre newsletter.
      pop.addEventListener('click', function (event) {
        if (event.target === pop) pop.close();
      });

      // ?contact_posted=true est le marqueur de Shopify, et il reste dans la
      // barre d'adresse : rafraîchir rouvrirait la fenêtre sur un message qui
      // n'a pas été renvoyé. On l'efface tout de suite, sans recharger ni
      // empiler d'entrée dans l'historique.
      //
      // Ici et non sur l'événement `close` : le showModal() ci-dessus commence
      // par un close(), qui émet ce même événement — le nettoyage s'y serait
      // déclenché au chargement de toute façon. Autant le dire franchement.
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        if (url.searchParams.has('contact_posted')) {
          url.searchParams.delete('contact_posted');
          window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
